import { render, staticRenderFns } from "./HasUnseenCommentsMarker.vue?vue&type=template&id=c6283c82&scoped=true&"
import script from "./HasUnseenCommentsMarker.vue?vue&type=script&lang=js&"
export * from "./HasUnseenCommentsMarker.vue?vue&type=script&lang=js&"
import style0 from "./HasUnseenCommentsMarker.vue?vue&type=style&index=0&id=c6283c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6283c82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6283c82')) {
      api.createRecord('c6283c82', component.options)
    } else {
      api.reload('c6283c82', component.options)
    }
    module.hot.accept("./HasUnseenCommentsMarker.vue?vue&type=template&id=c6283c82&scoped=true&", function () {
      api.rerender('c6283c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Comments/HasUnseenCommentsMarker.vue"
export default component.exports